"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSRFetchClient = exports.useSSRDataContextValue = exports.useSSRDataContextProvider = exports.SSRDataContext = exports.SSRFetchConfig = void 0;
exports.useSSRFetchClient = useSSRFetchClient;
exports.useSSRFetch = useSSRFetch;
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const types_1 = require("@src/types");
const useIsFirstRender_1 = require("@src/hooks/useIsFirstRender");
exports.SSRFetchConfig = {
    partners: {
        key: 'unique-initial-state-partners',
        fetch: Api.Cms.Web.getPartners,
    },
    testimonials: {
        key: 'unique-initial-state-testimonials',
        fetch: (locale = types_1.SupportedLanguage.sk) => Api.Cms.Web.getTestimonials({ locale }),
    },
    teamPeople: {
        key: 'unique-initial-state-team-people',
        fetch: Api.Cms.Web.getTeam,
    },
    companyProfile: {
        key: 'unique-initial-state-company-profile',
        fetch: (companyUniqueUrl) => Api.Company.getCompanyByUrl(companyUniqueUrl),
    },
    magazinePosts: {
        key: 'unique-initial-state-magazine-posts',
        fetch: (currentPage) => Api.Cms.Magazine.getPosts(currentPage),
    },
    magazinePostsCount: {
        key: 'unique-initial-state-magazine-posts-count',
        fetch: Api.Cms.Magazine.getPostsCount,
    },
    magazinePost: {
        key: 'unique-initial-state-magazine-post',
        fetch: (slug) => Api.Cms.Magazine.getPost({ slug }),
    },
    companiesList: {
        key: 'unique-initial-state-companies-list',
        fetch: (params) => Api.Company.getCompaniesForList(params === null || params === void 0 ? void 0 : params.search, params === null || params === void 0 ? void 0 : params.page),
    },
    companiesListPreview: {
        key: 'unique-initial-state-companies-list-preview',
        fetch: (params) => Api.Company.getCompaniesForListPreview(params.limit),
    },
    companies: {
        key: 'unique-initial-state-search-companies',
        fetch: (companiesIds) => Api.Company.getCompaniesByIds(companiesIds),
    },
    highestSalary: {
        key: 'unique-initial-state-highest-offer-salary',
        fetch: (salaryRate) => Api.Offers.getHighestSalaryByRate(salaryRate),
    },
    globalHighestSalary: {
        key: 'unique-initial-state-global-highest-offer-salary',
        fetch: () => Api.Offers.getHighestSalaryByRate(types_1.SalaryRate.monthly),
    },
    offersFilters: {
        key: 'unique-initial-state-offers-filters',
        fetch: (query) => Api.OffersFilters.getOffersFilters(query),
    },
    offers: {
        key: 'unique-initial-state-offers',
        fetch: (query) => Api.Offers.getOffers(query),
    },
    promotedOffers: {
        key: 'unique-initial-state-promoted-offers',
        fetch: (query) => Api.Offers.getPromotedOffers(query),
    },
    account: {
        key: 'unique-initial-state-account',
        fetch: Api.Account.getAccount,
    },
    offerDetail: {
        key: 'unique-initial-state-offer-detail',
        fetch: ({ offerId, offerSlug }) => Api.Offers.getOfferDetail({ offerId, offerSlug }),
    },
    suggestedSimilarOffers: {
        key: 'unique-initial-state-suggested-similar-offers',
        fetch: (offerId) => Api.Offers.getSuggestedSimilarOffers(offerId),
    },
    suggestedSameCompanyOffers: {
        key: 'unique-initial-state-suggested-same-company-offers',
        fetch: (offerId) => Api.Offers.getSuggestedSameCompanyOffers(offerId),
    },
};
exports.SSRDataContext = react_1.default.createContext({
    SSRContext: {},
    setSSRContext: () => { },
});
const useSSRDataContextProvider = () => {
    const isServer = typeof window === 'undefined';
    const initialContextValue = {};
    if (!isServer) {
        Object.values(exports.SSRFetchConfig).forEach(({ key }) => {
            if (window[key]) {
                initialContextValue[key] = window[key];
                delete window[key];
            }
        });
    }
    const [SSRContext, setSSRContext] = react_1.default.useState(initialContextValue);
    return {
        SSRDataContextProvider: exports.SSRDataContext.Provider,
        value: {
            SSRContext,
            setSSRContext,
        },
    };
};
exports.useSSRDataContextProvider = useSSRDataContextProvider;
const useSSRDataContextValue = () => {
    const context = react_1.default.useContext(exports.SSRDataContext);
    return context;
};
exports.useSSRDataContextValue = useSSRDataContextValue;
exports.SSRFetchClient = {
    invalidateSSRContext: (key) => {
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent(key));
        }
    },
};
function useSSRFetchClient() {
    return exports.SSRFetchClient;
}
function useSSRFetch(globalStateKey, fetchArgs = undefined, dependencies = []) {
    const isServer = typeof window === 'undefined';
    const { SSRContext, setSSRContext } = (0, exports.useSSRDataContextValue)();
    const [state, setState] = react_1.default.useState(SSRContext[globalStateKey]);
    const [error, setError] = react_1.default.useState(null);
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const isFirstRender = (0, useIsFirstRender_1.useIsFirstRender)();
    const [refetchPromise, setRefetchPromise] = react_1.default.useState({
        resolve: (_value) => { },
        reject: (_error) => { },
    });
    if (isServer && state === undefined) {
        // eslint-disable-next-line no-console
        console.error('[ERROR] SSR fetch did not match route in prefetch-routes for following key:', globalStateKey, 'on route:', typeof window === 'undefined' ? 'server-side rendering' : window.location.pathname);
    }
    react_1.default.useEffect(() => {
        // this fixes race condition
        let isActive = true;
        const fetch = async () => {
            var _a;
            setIsLoading(true);
            try {
                const fetchRequest = (_a = Object.values(exports.SSRFetchConfig).find(obj => obj.key === globalStateKey)) === null || _a === void 0 ? void 0 : _a.fetch;
                const data = await fetchRequest(fetchArgs);
                if (isActive) {
                    setState(data);
                }
                refetchPromise.resolve(data);
            }
            catch (err) {
                console.error(err);
                setError(err);
                refetchPromise.reject(err);
            }
            finally {
                setIsLoading(false);
            }
        };
        if ((isFirstRender && !state) || !isFirstRender) {
            fetch();
        }
        return () => {
            isActive = false;
        };
    }, [...dependencies, refetchPromise]);
    const refetch = react_1.default.useCallback(() => {
        return new Promise((resolve, reject) => {
            setRefetchPromise({
                resolve,
                reject,
            });
        });
    }, []);
    react_1.default.useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener(globalStateKey, () => {
                if (SSRContext[globalStateKey] && setSSRContext) {
                    setSSRContext({});
                }
                refetch();
            });
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener(globalStateKey, () => {
                    refetch();
                });
            }
        };
    }, [SSRContext]);
    if (state) {
        return { data: state, isLoading, error, refetch };
    }
    return { data: null, isLoading, error, refetch };
}
